import toArray from 'arrayify';
import BEM from 'bem.js';

const BLOCK_DROPDOWN = 'dropdown';

const ELEMENT_LIST = 'list';

const MODIFIER_ACTIVE = 'active';


class Dropdown {
    constructor(items) {
        toArray(items).forEach(this.initEventHandlers.bind(this));
    }

    initEventHandlers(item) {
        item.addEventListener('click', (event) => {
            event.preventDefault();
            BEM.addModifier(item, MODIFIER_ACTIVE);
            let popover = document.createElement('div');
            popover.classList.add('popover');
            document.querySelector('body').appendChild(popover);

            popover.addEventListener('click', () => {
                BEM.removeModifier(item, MODIFIER_ACTIVE);
                popover.remove();
            });
        });

        let list = BEM.getChildBEMNode(item, BLOCK_DROPDOWN, ELEMENT_LIST);
        list.addEventListener('click', (event) => {
            event.stopPropagation();
        });
    }
}


let items = BEM.getBEMNodes(BLOCK_DROPDOWN);
new Dropdown(items);



// WEBPACK FOOTER //
// ./src/my_artis/js/components/dropdown.js